import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import TrackPayment from "./Tabs/TrackPayment";
import PlaceOrderDetailsPage from "./Tabs/PlaceOrderDetailsPage";

export default function PlaceOrderDetails() {
  const [activeTab, setActiveTab] = useState("details");
  const location = useLocation();
  const navigate = useNavigate();
  const params = new URLSearchParams(location.search);
  const orderId = params.get("id");
  const tabName = params.get("tab");

  const handleTabChange = (tabName) => {
    setActiveTab(tabName);
    navigate(`?id=${orderId}&tab=${tabName}`);
  };

  useEffect(() => {
    setActiveTab(tabName);
  }, [tabName]);

  return (
    <div className="content-body">
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-12 col-lg-12">
            <div className="card">
              <div
                className="card-header card-header2"
                style={{ paddingBottom: "12px" }}
              >
                <div className="d-flex">
                  <Link
                    to={`?id=${orderId}&tab=details`}
                    className={`${
                      activeTab === "details" ? "active-tab" : ""
                    } card-title--medium card-title2`}
                    onClick={() => handleTabChange("details")}
                  >
                    Order Details
                  </Link>

                  <Link
                    to={`?id=${orderId}&tab=payment`}
                    className={`${
                      activeTab === "payment" ? "active-tab" : ""
                    } card-title--medium card-title2 ms-5`}
                    onClick={() => handleTabChange("payment")}
                  >
                    Payment Summary
                  </Link>
                </div>
                <div className="d-flex">
                  <h5 className="order-id card-title--medium card-title2 back-head">
                    Order: #{orderId}
                  </h5>
                  <Link to="/place-order">
                    <img
                      src="/assets/images/kidskart/icon/back-button.png"
                      alt="Back"
                    />
                  </Link>{" "}
                </div>
              </div>

              {/* Tab Content */}
              <div className="tab-content">
                {activeTab === "details" && <PlaceOrderDetailsPage />}
                {activeTab === "payment" && <TrackPayment />}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
